
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/chat/chat-composer-attachment-list",
      function () {
        return require("private-next-pages/x/api/chat/chat-composer-attachment-list.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/chat/chat-composer-attachment-list"])
      });
    }
  